export const getCamelCase = (str) =>{
    return str.replace(str[0],str[0].toUpperCase())
}